/**
 * Formats a number with thousands separators
 * @param {number} num - The number to format
 * @param {string} locale - The locale to use for formatting (default: 'es-ES')
 * @returns {string} - Formatted number string
 */
export function formatNumber(num, locale = 'es-ES') {
    if (num === null || num === undefined || isNaN(num)) return '0';

    // Use toLocaleString with explicit options to ensure thousands separator
    return Number(num).toLocaleString(locale, {
        useGrouping: true,
        maximumFractionDigits: 0
    });
}

/**
 * Formats a decimal number with thousands separators and fixed decimal places
 * @param {number} num - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @param {string} locale - The locale to use for formatting (default: 'es-ES')
 * @returns {string} - Formatted number string
 */
export function formatDecimal(num, decimals = 2, locale = 'es-ES') {
    if (num === null || num === undefined || isNaN(num)) return '0';
    return Number(num).toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
}

/**
 * Formats an amount in USD (e.g. $1.250,00)
 * @param {number} num - The amount to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @param {string} locale - The locale to use for formatting (default: 'es-ES')
 * @returns {string} - Formatted currency string
 */
export function formatCurrency(num, decimals = 2, locale = 'es-ES') {
    return `$${formatDecimal(num ?? 0, decimals, locale)}`;
}
